const TileIP = ({ data = {}, t }) => {
  const s = (v) => (v ?? "").toString().trim();

  const getVal = (arr, type) => {
    if (!Array.isArray(arr)) return "";
    const found = arr.find((x) => x.type?.toLowerCase() === type.toLowerCase());
    return s(found?.data ?? "");
  };

  const ip = s(data.ip_address);
  const commonName = s(data.common_name);
  const nameValue = s(data.name_value);

  if (!ip && !commonName) return null;

  const asn = getVal(data.Info, "ASN");
  const cidr = getVal(data.Info, "CIDR");
  const rdns = getVal(data.Info, "RDNS");
  const country = getVal(data.Location, "Country");
  const city = getVal(data.Location, "City");
  const location = [city && city !== "false" ? city : null, country]
    .filter(Boolean)
    .join(", ");

  const blacklisted = Array.isArray(data.Blacklist)
    ? data.Blacklist.some((b) => b.data && b.data !== "Not listed")
    : false;

  const services = Array.isArray(data.Services)
    ? data.Services.filter((sv) => sv.data === "Open").map((sv) => sv.type)
    : [];

  const names = nameValue.split("\n").filter(Boolean);

  const labelStyle = {
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 500,
    color: t.textMuted,
    margin: 0,
  };

  const valStyle = {
    fontSize: 13,
    color: t.textSecondary,
    margin: 0,
    wordBreak: "break-word",
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* IP + blacklist badge */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <p
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: t.textPrimary,
              margin: 0,
              fontFamily: "monospace",
            }}
          >
            {ip}
          </p>
          {blacklisted && (
            <span
              style={{
                fontSize: 11,
                padding: "2px 8px",
                borderRadius: 6,
                background: "rgba(239,68,68,0.12)",
                border: "1px solid rgba(239,68,68,0.25)",
                color: "rgb(248,113,113)",
              }}
            >
              Blacklisted
            </span>
          )}
        </div>

        {/* Common name */}
        {commonName && (
          <p style={{ fontSize: 13, color: t.textSecondary, margin: 0 }}>
            {commonName}
          </p>
        )}

        {/* Name values as badges */}
        {names.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {names.map((n, i) => (
              <span
                key={i}
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {n}
              </span>
            ))}
          </div>
        )}

        {/* Details */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            paddingTop: 12,
            borderTop: `1px solid ${t.divider}`,
          }}
        >
          {location && (
            <div>
              <p style={labelStyle}>Location</p>
              <p style={valStyle}>{location}</p>
            </div>
          )}
          {asn && (
            <div>
              <p style={labelStyle}>ASN</p>
              <p style={{ ...valStyle, fontFamily: "monospace" }}>{asn}</p>
            </div>
          )}
          {cidr && (
            <div>
              <p style={labelStyle}>CIDR</p>
              <p style={{ ...valStyle, fontFamily: "monospace" }}>{cidr}</p>
            </div>
          )}
          {rdns && rdns !== "None" && !rdns.endsWith("None") && (
            <div>
              <p style={labelStyle}>RDNS</p>
              <p style={{ ...valStyle, fontFamily: "monospace", fontSize: 11 }}>
                {rdns}
              </p>
            </div>
          )}
          {services.length > 0 && (
            <div>
              <p style={labelStyle}>Open Services</p>
              <div
                style={{
                  display: "flex",
                  gap: 6,
                  flexWrap: "wrap",
                  marginTop: 4,
                }}
              >
                {services.map((svc) => (
                  <span
                    key={svc}
                    style={{
                      fontSize: 11,
                      padding: "2px 8px",
                      borderRadius: 6,
                      background: "rgba(34,197,94,0.1)",
                      border: "1px solid rgba(34,197,94,0.2)",
                      color: "rgb(74,222,128)",
                    }}
                  >
                    {svc}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TileIP;
